import Image from '@tiptap/extension-image';
import { ReactNodeViewRenderer } from '@tiptap/react';
import ImageComponent from './ImageComponent';

const CustomImage = Image.extend({
  addAttributes() {
    return {
      ...(this.parent?.() || {}),
      class: {
        default: '',
        renderHTML: (attributes) => {
          return {
            class: `${attributes.class}`
          };
        }
      },
      ['data-parent']: {
        default: '',
        renderHTML: (attributes) => {
          return {
            ['data-parent']: `${attributes['data-parent']}`
          };
        }
      }
    };
  },
  addNodeView() {
    return ReactNodeViewRenderer(ImageComponent);
  }
});

export default CustomImage;
